<template>
  <v-dialog v-model="dialogLogin" width="340">
    <v-card color="primary" dark>
      <v-container grid-list-md text-xs-center>
        <!-- <v-layout row wrap v-if="browser != 'safari'">
          <v-flex xs12 v-if="!emailSent">
            <div class="mb-3">Bonjour {{ title }},</div>
            <div class="mb-3">Veuillez entrer votre email pour vous authentifier.</div>
            <v-text-field
              label="Solo"
              v-model.trim="email"
              placeholder="Votre email"
              solo
              :rules="emailRules"
            ></v-text-field>
            <v-btn
              class="secondary primary--text text-none mt-0"
              :disabled="validEmail()"
              @click="loginWithoutPassword()"
              round
            >Envoyer</v-btn>
          </v-flex>
          <v-flex xs12 v-else>
            <div>
              Un email d'authentification vous a été envoyé.
              <br>Veuillez vérifier votre boîte mail.
            </div>
            <div
              class="no-email mt-3"
              @click="emailSent = false"
            >Je n'ai pas reçu d'email d'authentification...</div>
          </v-flex>
        </v-layout>-->

        <!-- if SAFARI (v-else) -->
        <v-layout row wrap v-if="!user && ! userBuffer">
          <v-flex xs12>
            <div class="mb-3">Bonjour {{ title }},</div>
            <div class="mb-3">Veuillez entrer votre email pour vous authentifier.</div>
            <v-text-field
              label="Solo"
              v-model.trim="email"
              placeholder="Votre email"
              solo
              :rules="emailRules"
            ></v-text-field>
            <v-layout row wrap v-if="emailIsCorrect()">
              <v-flex xs12>
                <v-text-field
                  v-model="password"
                  :append-icon="show ? 'visibility' : 'visibility_off'"
                  :rules="[passwordRules.required, passwordRules.min]"
                  :type="show ? 'text' : 'password'"
                  name="input-10-1"
                  label="Mot de passe"
                  hint="Mininum 8 caractères"
                  counter
                  solo
                  @click:append="show = !show"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 mt-3>
                <v-btn
                  class="secondary primary--text text-none mt-0"
                  :disabled="!longEnoughPassword()"
                  @click="signIn()"
                  round
                  :loading="loading"
                >Se connecter</v-btn>
                <v-btn
                  class="secondary primary--text text-none mt-0"
                  :disabled="!longEnoughPassword()"
                  @click="signUp()"
                  round
                  :loading="loading"
                >Créer un compte</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="user || userBuffer">
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs12 mt-3>
                <v-btn
                  class="secondary primary--text text-none mt-0"
                  @click="signout()"
                  round
                  :loading="loading"
                >Se déconnecter</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import firebase from "../firebaseConfig.js";
import { mapState } from "vuex";

export default {
  data() {
    return {
      emailSent: false,
      email: "",
      password: "",
      show: false,
      emailRules: [
        v => !!v || "Votre email est requis",
        v => /\S+@\S+\.\S+/.test(v) || "L'email doit être valide"
      ],
      passwordRules: {
        required: value => !!value || "Le mot de passe est requis",
        min: v => v.length >= 8 || "Mininum 8 caractères"
      }
    };
  },
  props: ["title"],
  mounted() {
    // Confirm the link is a sign-in with email link.
    // if (!window.location.href) return;
    // if (firebase.auth().isSignInWithEmailLink(window.location.href)) {
    //   // Additional state parameters can also be passed via URL.
    //   // This can be used to continue the user's intended action before triggering
    //   // the sign-in operation.
    //   // Get the email if available. This should be available if the user completes
    //   // the flow on the same device where they started it.
    //   var email = window.localStorage.getItem("emailForSignIn");
    //   if (!email) {
    //     // User opened the link on a different device. To prevent session fixation
    //     // attacks, ask the user to provide the associated email again. For example:
    //     email = window.prompt("Veuillez entrer votre email de confirmation");
    //   }
    //   // The client SDK will parse the code from the link for you.
    //   let self = this;
    //   firebase
    //     .auth()
    //     .signInWithEmailLink(email, window.location.href)
    //     .then(function(result) {
    //       // Clear email from storage.
    //       window.localStorage.removeItem("emailForSignIn");
    //       // You can access the new user via result.user
    //       self.$store.commit("setUser", result.user);
    //       self.$store.commit("setSnackbar", {
    //         color: "success",
    //         timeout: 3000,
    //         text: "Vous êtes maintenant connecté"
    //       });
    //       self.$router.push("/");
    //       // Additional user info profile not available via:
    //       // result.additionalUserInfo.profile == null
    //       // You can check if the user is new or existing:
    //       // result.additionalUserInfo.isNewUser
    //     })
    //     .catch(function(error) {
    //       console.log("erreur :");
    //       console.log(error);
    //       // Some error occurred, you can inspect the code: error.code
    //       // Common errors could be invalid email and invalid or expired OTPs.
    //     });
    // }
  },
  methods: {
    validEmail() {
      return !/\S+@\S+\.\S+/.test(this.email);
    },
    longEnoughPassword() {
      return this.password.length >= 8 ? true : false;
    },
    emailIsCorrect() {
      this.email = this.email.toLowerCase();
      return this.email == "felixbecquart1990@gmail.com" ||
        this.email == "becquartsf@gmail.com"
        ? true
        : false;
    },
    signout() {
      this.$store.commit("setLoading", true);
      let self = this;
      firebase
        .auth()
        .signOut()
        .then(function() {
          self.$store.commit("setSnackbar", {
            color: "success",
            timeout: 3000,
            text: "Vous avez bien été déconnecté"
          });
          self.$store.commit("setLoading", false);
          self.dialogLogin = false;
        })
        .catch(function(error) {
          self.$store.commit("setLoading", false);
          self.$store.commit("setSnackbar", {
            color: "error",
            timeout: 5000,
            text: errorMessage
          });
        });
    },
    // resetPassword() {
    //   var auth = firebase.auth();
    //   var emailAddress = "user@example.com";

    //   auth
    //     .sendPasswordResetEmail(emailAddress)
    //     .then(function() {
    //       // Email sent.
    //     })
    //     .catch(function(error) {
    //       // An error happened.
    //     });
    // },
    signIn() {
      this.$store.commit("setLoading", true);
      let self = this;
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(function() {
          self.$store.commit("setSnackbar", {
            color: "success",
            timeout: 4000,
            text:
              "Félicitation, vous êtes maintenant connecté en tant qu'administrateur"
          });
          self.$store.commit("setLoading", false);
          self.dialogLogin = false;
        })
        .catch(function(error) {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          self.$store.commit("setLoading", false);
          self.$store.commit("setSnackbar", {
            color: "error",
            timeout: 5000,
            text: errorMessage
          });
        });
    },
    signUp() {
      this.$store.commit("setLoading", true);
      let self = this;
      firebase
        .auth()
        .createUserWithEmailAndPassword(this.email, this.password)
        .then(function() {
          self.$store.commit("setSnackbar", {
            color: "success",
            timeout: 3000,
            text:
              "Félicitation, vous êtes maintenant connecté en tant qu'administrateur"
          });
          self.$store.commit("setLoading", false);
          self.dialogLogin = false;
        })
        .catch(function(error) {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          self.$store.commit("setLoading", false);
          self.$store.commit("setSnackbar", {
            color: "error",
            timeout: 5000,
            text: errorMessage
          });
        });
    }
    // loginWithoutPassword() {
    //   this.email = this.email.toLowerCase();
    //   if (!this.emailIsCorrect()) {
    //     this.$store.commit("setSnackbar", {
    //       color: "error",
    //       timeout: 3000,
    //       text: "Accès non autorisé"
    //     });
    //     this.dialogLogin = false;
    //     return;
    //   }
    //   this.emailSent = true;
    //   var actionCodeSettings = {
    //     // URL you want to redirect back to. The domain (www.example.com) for this
    //     // URL must be whitelisted in the Firebase Console.
    //     url: "https://syl-vain.firebaseapp.com",
    //     // url: "http://localhost:8080",
    //     // This must be true.
    //     handleCodeInApp: true
    //   };
    //   let self = this;
    //   firebase
    //     .auth()
    //     .sendSignInLinkToEmail(self.email, actionCodeSettings)
    //     .then(function() {
    //       // The link was successfully sent. Inform the user.
    //       // Save the email locally so you don't need to ask the user for it again
    //       // if they open the link on the same device.
    //       window.localStorage.setItem("emailForSignIn", self.email);
    //     })
    //     .catch(function(error) {
    //       console.log("erreur :");
    //       console.log(error);
    //       // Some error occurred, you can inspect the code: error.code
    //     });
    // }
  },
  computed: {
    ...mapState(["user", "userBuffer", "browser", "loading"]),
    dialogLogin: {
      get: function() {
        return this.$store.state.dialogLogin;
      },
      set: function(newValue) {
        this.$store.commit("setDialogLogin", newValue);
      }
    }
  }
};
</script>

<style scoped>
.no-email {
  font-size: 10px;
  text-decoration: underline;
  cursor: pointer;
}
.password {
  animation: fadein 0.5s;
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
